export default "__VITE_ASSET__ccf4af71__"